import { detectLocale } from '#lib/helper/locale.js';

export enum CurrencyCode {
	EUR = 'EUR'
}

export function formatCurrency(
	value: number,
	currencyCode: CurrencyCode | string,
	showCents = true,
	centsPrecision = 2,
	locale?: string
): string {
	const activeLocale = locale ?? detectLocale();
	return new Intl.NumberFormat(activeLocale, {
		style: 'currency',
		currency: currencyCode,
		minimumFractionDigits: showCents ? centsPrecision : 0,
		maximumFractionDigits: showCents ? centsPrecision : 0
	}).format(value);
}

export function formatNumber(value: number, locale?: string): string {
	const activeLocale = locale ?? detectLocale();
	return new Intl.NumberFormat(activeLocale).format(value);
}
